export const projects = [
	{
		name: "Portfolio Website",
		description:
			"A responsive personal portfolio website created with vite, React, CSS3. Showcasing my web development career milestone, skills, project work",
		technology: ["React", "Vite", "CSS3", "Express", "Redux"],
		imgSrc: "/images/portfolio/Personal website.jpg",
		alt: "Portfolio",
		link: "https://junfel.com",
		analytics: "https://pagespeed.web.dev/analysis/https-junfel-com/5rfmiwszrm?form_factor=desktop",
	},
	{
		name: "Ecommerce API Documentation",
		description:
			"Dynamic system with routes for order processing, real-time inventory updates, and secure authentication. Supports automated order reporting and product management. API documented publicly with Postman.",
		technology: ["Node.js", "Express", "MongoDB", "Postman"],
		imgSrc: "/images/portfolio/API-Ecommerce.jpg",
		alt: "API Documentation",
		link: "https://documenter.getpostman.com/view/24720918/2sB34hEf5B",
	},
	{
		name: "CapCakes - Ecommerce App",
		description:
			"E-Commerce Platform with a dynamic product catalog, advanced search and filtering, seamless cart management, secure checkout, and an admin dashboard for analytics and user management",
		technology: ["Vue", "Bootstrap", "Pinia", "JWT", "AWS"],
		imgSrc: "/images/portfolio/CapCakes Ecommerce.jpg",
		alt: "CapCakes",
		link: "http://zuitt-bootcamp-prod-560-8930-velasco.s3-website.us-east-1.amazonaws.com/",
	},
	{
		name: "Asuncion's Purplehub - Cakes",
		description:
			"Static website created with Next.js. Asuncion's Purplehub is an online bakery specializing in premium, freshly baked Filipino desserts, most notably cakes and pastries made with Ube",
		technology: ["Next.js", "Tailwind CSS", "Vercel", "Swiper"],
		imgSrc: "/images/portfolio/laptop-purplehub.webp",
		alt: "Purplehub",
		link: "https://purplehub.vercel.app",
	},
	{
		name: "Gigafit - Fitness Tracker App",
		description:
			"It's a personal fitness app tracker to track your progress with your desired custom workout and schedule.",
		technology: ["React", "Bootstrap", "Vercel", "React Router"],
		imgSrc: "/images/portfolio/Gigafit.jpg",
		alt: "Portfolio",
		link: "https://gigafit-rho.vercel.app/",
	},
	{
		name: "J-Flix - Movie App",
		description:
			"Web application that enables users to search the most latest Movie and TV-show with a highest rating and other details. Integrates with TMDB API",
		technology: ["JavaScript", "CSS3", "HTML5", "TMDB API"],
		imgSrc: "/images/portfolio/laptop-jflix.webp",
		alt: "Portfolio",
		link: "https://j-flix.netlify.app",
	},
	{
		name: "Limited Art - Ecommerce App",
		description:
			"An ecommerce application where user can buy and sell painting. It's fully responsive design using MongoDB, Express, React, Node.js (MERN) stack, with full authentication capability, JWT token, SEO support, Cloudinary for image storage, and deployed on Hostinger.",
		technology: ["MongoDB", "Express", "React", "Node.js", "Cloudinary"],
		imgSrc: "/images/portfolio/laptop-limitedart.webp",
		alt: "Limited Art",
		link: "https://limitedart.junfel.com/",
		analytics: "https://pagespeed.web.dev/analysis/https-limitedart-junfel-com/9mr2y3i9px?form_factor=desktop",
	},
	{
		name: "Limited Art - Prototype Design",
		description:
			"It's an initial prototype design in Figma for a painting e-commerce website. A side project that I am currently working on.",
		technology: ["Figma"],
		imgSrc: "/images/portfolio/Limited art - figma.jpg",
		alt: "Limited Art",
		link: "https://www.figma.com/design/3Xn2L22rWcmA01QdQPPBOj/Limited-Art?node-id=86-7&t=DZVrFeqIhmhieNlU-1",
	},
];

export const ProjectWeb = [
	{
		title: "Web projects 1",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "",
		imgAlt: "img-alt",
	},
	{
		title: "Web projects 2",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "/img-src",
		imgAlt: "img-alt",
	},
	{
		title: "Web projects 3",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "/img-src",
		imgAlt: "img-alt",
	},
];

export const Project3d = [
	{
		title: "3D projects 1",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "",
		imgAlt: "img-alt",
	},
	{
		title: "3D projects 2",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "/img-src",
		imgAlt: "img-alt",
	},
	{
		title: "3D projects 3",
		description:
			"Project description Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, tempore! Ipsa odit eos dolores possimus optio praesentium fugit! Doloremque repellendus veniam eius nostrum omnis quibusdam libero magnam repellat, amet itaque!",
		imgSrc: "/img-src",
		imgAlt: "img-alt",
	},
];
